import { render, staticRenderFns } from "./sales-news.vue?vue&type=template&id=dc1e49f0"
import script from "./sales-news.vue?vue&type=script&lang=js"
export * from "./sales-news.vue?vue&type=script&lang=js"
import style0 from "./sales-news.vue?vue&type=style&index=0&id=dc1e49f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports